<template>
  <div>
    <b-container fluid>
 

  <b-row>
    <!-- Per Page Dropdown -->
    <b-col cols="12" sm="4"  class="mb-1">
      <b-form-group class="mb-0"
      label="Per page"  
     
        label-size="sm">
       
        
        <b-form-select
        
          id="perPageSelect"
          v-model="perPage"
          :options="pageOptions.map(option => ({ text: option, value: option }))"
          size="sm"
          class="w-100"
        />
      </b-form-group>
    </b-col>

    <!-- Campaign Filter -->
    <b-col cols="12" sm="4"  class="mb-1">
      <b-form-group
        label="Filter by Campaign"
       
    
        label-size="sm"
      >
        <b-form-select
          v-model="selectedCampaignId"
          :options="campaignOptions"
          @change="filterLeads"
          size="sm"
          class="w-100"
        >
        </b-form-select>
      </b-form-group>
    </b-col>

    <!-- Search Filter -->
    <b-col cols="12"  sm="4" class="mb-1">
      <b-form-group
        label="Filter"
       
        label-size="sm"
        label-for="filterInput"
        class="mb-0"
      >
        <b-input-group size="sm">
          <b-form-input
            id="filterInput"
            v-model="searchQuery"
            @input="onSearch"
            type="search"
            placeholder="Type to Search"
          />
          <b-input-group-append>
            <b-button :disabled="!searchQuery" @click="searchQuery = ''">
              Clear
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </b-col>
  </b-row>
  <b-row>
    <!-- Header Section -->
    <b-col cols="12"   class="d-flex justify-content-end mb-3">
      <b-button variant="primary" @click="$bvModal.show('add-lead-modal')">
        Add Marketing Lead
      </b-button>
    </b-col>
  </b-row>
</b-container>


  <b-row>
   
    <b-col cols="12">
      <b-table
      striped
      hover
      responsive
      :items="filteredLeads"
      :fields="fields"
      :per-page="perPage"
      :current-page="currentPage"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      v-if="!loading"
    >
      <template #cell(actions)="data">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template #button-content>
            <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
          </template>
          <b-dropdown-item @click="prepareEditLead(data.item)" :disabled="data.item.salesConversion === true">
            <feather-icon icon="EditIcon" class="mr-50" />
            <span>Edit</span>
          </b-dropdown-item>
          <b-dropdown-item v-if="HasPermission(PermissionList.Sales_Create)" @click="convertLead(data.item.leadId)"
          :disabled="data.item.salesConversion === true">
            <feather-icon icon="EyeIcon" class="mr-50" />
            <span>Convert</span>
          </b-dropdown-item>
        </b-dropdown>
      </template>

      <template #cell(campaignId)="data">
        {{ getCampaign(data.item.campaignId) }}
      </template>

      <template #cell(salesConversion)="data">
        {{ getSalesConversion(data.item.salesConversion) }}
      </template>
    </b-table>
      <div class="d-flex justify-content-center mb-1">
        <b-spinner variant="success" label="Spinning" block v-if="loading"
          style="width: 3rem; height: 3rem"></b-spinner>
      </div>
      <b-col cols="12" v-if="!loading">
        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="center" size="sm"
          class="my-0"></b-pagination>
      </b-col>
    </b-col>



    <!-- Modal for add -->
    <b-modal id="add-lead-modal" title="Add Marketing Lead" @ok.prevent="onSubmit" @hidden="resetForm">
      <b-row>
        <b-col cols="12">
          <b-card title="Add Marketing Lead" class="mb-3">
            <validation-observer ref="AddForm">
              <b-form @submit.prevent="onSubmit">
                <!-- Name Field -->
                <b-form-group  label-for="lead-name">
                    <template #label>
                          Lead First Name: <span class="text-danger">(*)</span>
                    </template>
                  <validation-provider #default="{ errors }" name="Lead First Name" vid="Lead First Name"
                    rules="required|name">
                    <b-form-input id="lead-name" type="text" v-model="form.FirstName"
                      placeholder="Enter lead first name" required></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <b-form-group  label-for="lead-name">
                  <template #label>
                        Lead Last Name: <span class="text-danger">(*)</span>
                  </template>
                  <validation-provider #default="{ errors }" name="Lead Last Name" vid="Lead Last Name"
                    rules="required|name">
                    <b-form-input id="lead-name" type="text" v-model="form.LastName" placeholder="Enter lead last name"
                      required></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- Email Field -->
                <b-form-group label="Email Address:" label-for="lead-email">
                  <validation-provider rules="email" v-slot="{ errors }" name="Lead email" vid="Lead emai">
                    <b-form-input id="lead-email" type="email" v-model="form.email"
                      placeholder="Enter email (optional)"></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- Source Field -->
                <b-form-group label-for="lead-source">
                  <template #label>
                        Lead Source: <span class="text-danger">(*)</span>
                  </template> 
                  <validation-provider #default="{ errors }" name="Source" vid="Source" rules="required">
                    <b-form-select id="lead-source" v-model="form.source" :options="sources" required></b-form-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- Associated Campaign Field -->
                <b-form-group  label-for="campaigns">
                  <template #label>
                        Associated Campaign: <span class="text-danger">(*)</span>
                  </template> 
                  <validation-provider #default="{ errors }" name="Campaign" vid="Campaign" rules="required">
                    <b-form-select id="lead-campaign" v-model="form.campaignId" :options="campaigns"
                      required></b-form-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-form>
            </validation-observer>
          </b-card>
        </b-col>

      </b-row>
      <template #modal-footer="{ ok }">
        <b-button type="submit" variant="primary" :disabled="submitting" @click="onSubmit">
          <b-spinner small v-if="submitting"></b-spinner>
          {{ submitting ? 'Adding...' : 'Add' }}
        </b-button>
      </template>
    </b-modal>



    <b-modal id="edit-lead-modal" title="Edit Marketing Lead" @ok.prevent="onEditSubmit">
      <b-row>
        <b-col cols="12">
          <b-card title="Edit Marketing Lead" class="mb-3">
            <validation-observer ref="EditForm">
              <b-form @submit.prevent="onEditSubmit">
                <b-form-group label="Lead First Name:" label-for="edit-lead-first-name">
                  <validation-provider
                    #default="{ errors }"
                    name="Lead First Name"
                    vid="Lead First Name"
                    rules="required|name"
                  >
                    <b-form-input
                      id="edit-lead-first-name"
                      type="text"
                      v-model="editForm.firstName"
                      placeholder="Enter lead first name"
                      :disabled="salesConversion"
                      required
                    ></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <b-form-group label="Lead Last Name:" label-for="edit-lead-last-name">
                  <validation-provider
                    #default="{ errors }"
                    name="Lead Last Name"
                    vid="Lead Last Name"
                    rules="required|name"
                  >
                    <b-form-input
                      id="edit-lead-last-name"
                      type="text"
                      v-model="editForm.lastName"
                      placeholder="Enter lead last name"
                      :disabled="salesConversion"
                      required
                    ></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <b-form-group label="Email Address:" label-for="edit-lead-email">
                  <validation-provider rules="email" v-slot="{ errors }" name="Lead email" vid="Lead email">
                    <b-form-input
                      id="edit-lead-email"
                      type="email"
                      v-model="editForm.email"
                      placeholder="Enter email (optional)"
                      :disabled="salesConversion"
                    ></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <b-form-group label="Lead Source:" label-for="edit-lead-source">
                  <validation-provider #default="{ errors }" name="Source" vid="Source" rules="required">
                    <b-form-select
                      id="edit-lead-source"
                      v-model="editForm.source"
                      :options="sources"
                      :disabled="salesConversion"
                      required
                    ></b-form-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <b-form-group label="Associated Campaign:" label-for="edit-lead-campaign">
                  <validation-provider #default="{ errors }" name="Campaign" vid="Campaign" rules="required">
                    <b-form-select
                      id="edit-lead-campaign"
                      v-model="editForm.campaignId"
                      :disabled="salesConversion"
                      :options="campaigns"
                      required
                    ></b-form-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-form>
            </validation-observer>
          </b-card>
        </b-col>
      </b-row>
      <template #modal-footer="{ ok }">
        <b-button type="submit" variant="primary" :disabled="salesConversion" @click="onEditSubmit">
          <b-spinner small v-if="submitting"></b-spinner>
          {{ submitting ? 'Updating...' : 'Update' }}
        </b-button>
      </template>
    </b-modal>
  </b-row>
</div>
</template>

<script>
import Ripple from "vue-ripple-directive";
import { PermissionList } from '@/libs/defaultList';
import { HasPermission } from '@/@core/utils/validations/permissionCheck';
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BAlert,
  BCol,
  BFormGroup,
  BFormSelect,
  BTab,
  BTabs,
  BContainer,
  BPagination,
  BInputGroup,
  BFormInput,
  BForm,
  BFormDatepicker,
  BInputGroupAppend,
  VBModal,
  BButton,
  BSpinner,
  BModal,
  BDropdown,
  BFormTextarea,
  BDropdownItem,
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { template } from "lodash";
export default {
  components: {
    BTable,
    BAvatar,
    BForm,
    BTab,
    BTabs,
    BModal,
    BBadge,
    BRow,
    BContainer,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    VBModal,
    BFormInput,
    BFormDatepicker,
    BFormTextarea,
    BInputGroupAppend,
    BButton,
    BSpinner,
    BAlert,
    BDropdown,
    BDropdownItem,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  data() {
    return {
      formState: {},
      selectedCampaignId: '',
      id: this.$route.params.id,
      selectedStatus: null,
      changingcomplaint: null,
      showModal: false,
      currentTab: 'All',
      searchQuery: '',
      pageOptions: [3, 5, 10],
      perPage: 5,
      //filterOn: ['salesConversion'],
      fields: [
        { key: "firstName", label: "First Name", sortable: true },
        { key: "lastName", label: "Last Name", sortable: true },
        { key: "email", label: "Email", sortable: true },
        { key: "source", label: "Source", sortable: true },
        // { key: "status", label: "Status", sortable: true },
        { key: "campaignId", label: "Campaign", sortable: true },
        { key: "salesConversion", label: "isConverted", sortable: true },
        { key: "actions" },
      ],
      currentPage: 1,
      perPage: 5,
      campaigns: [],
      salesConversion: false,
      form: {
        firstName: '',
        lastName: '',
        email: '',
        source: '',
        status: 'New',
        campaignId: "",
        isActive: true,
        salesConversion: null
      },

      editForm: {
        leadId: '',
        firstName: '',
        lastName: '',
        email: '',
        source: '',
        status: '',
        isActive: null,
        campaignId: '',
        salesConversion: null
      },
      sources: ['Facebook', 'Instagram', 'LinkedIn', 'Others'],
      sortBy: '',
      sortDesc: false,
      optionsCustomer: [],
      submitting: false,
    };
  },
  computed: {
    rows() {
      return this.filteredLeads.length;
    },
    campaignOptions() {
      return [{ value: '', text: 'All Campaigns' }].concat(
        this.marketingcampaign.map(campaign => ({
          value: campaign.id,
          text: campaign.name
        }))
      );
    },
    ...mapGetters("marketingleadsModule", {
      marketingleads: "marketingleads",
      loading: "loading",
    }),
    ...mapGetters("campaignModule", {
      marketingcampaign: "marketingcampaign",
      loading: "loading",
    }),
    filteredLeads() {
      return this.marketingleads.filter((lead) => {
        return (!this.searchQuery || Object.keys(lead).some(key =>
          String(lead[key]).toLowerCase().includes(this.searchQuery.toLowerCase()))) &&
          (!this.selectedCampaignId || lead.campaignId === this.selectedCampaignId);
      });
    },

    currentStatus() {
      const statusMapping = {
        0: 'All',
        1: 'New',
        2: 'InProgress',
        3: 'ClosedWon',
        4: 'ClosedLost'
      };

      return statusMapping[this.currentTab];
    },
  },

  methods: {
    ...mapActions("marketingleadsModule", ["getMarketingLeadAction", "postMarketingLeadAction", "putMarketingLeadAction", "convertToSalesAction"]),
    ...mapActions("campaignModule", ["getMarketingCampaignAction"]),


    resetForm() {
      this.form = {
        campaignId: "",
        firstName: '',
        lastName: '',
        email: '',
        source: '',
        status: 'New',
        isActive: true,
      };
    },


    getCampaign(id) {
      const campaign = this.marketingcampaign.find((s) => s.id === id);
      return campaign ? campaign.name : 'N/A';
    },

    getSalesConversion(salesConversion) {
      return salesConversion ? 'Yes' : 'No';
    },
//     getSalesConversion(salesConversion) {
// if(salesConversion == false){
//   return 'No'
// }
// else{
//   return 'Yes'
// }
//     },

    beautifyStatus(status) {
      return status
        .split(/(?=[A-Z])/)
        .join(' ')
        .trim();
    },

    prepareEditLead(lead) {
      console.log('Sales Conversion:', lead.salesConversion);
    this.salesConversion = Boolean(lead.salesConversion);
      this.editForm = { ...lead };
      this.$bvModal.show('edit-lead-modal');
    },


    async convertLead(id) {
      let loader = this.$swal({
        title: 'Processing...',
        text: 'Please wait while the marketing lead is being converted to sales lead',
        onOpen: () => {
          this.$swal.showLoading();
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
        buttonsStyling: false,
        showConfirmButton: false,
      });
      try {
        await this.convertToSalesAction(id);
        loader.close();
        this.success('Lead converted to sales successfully!');
      } catch (error) {
        loader.close();
        this.error(error.response.data.message);
      } finally {
        this.getMarketingLeadAction();
      }
    },




    promptChangeStatus(complaint) {
      this.changingcomplaint = complaint;
      this.selectedStatus = complaint.status;
      this.$bvModal.show("change-status-modal");
    },

    async onEditSubmit() {
      this.submitting = true;
      const isValid = await this.$refs.EditForm.validate();
      if (isValid) {

        try {
          await this.putMarketingLeadAction(this.editForm);
          this.success('Marketing Lead updated successfully!');

        } catch (error) {
          this.error('Failed to update the lead. Please try again.');
        } finally {
          this.submitting = false;
          this.$bvModal.hide('edit-lead-modal');
          this.getMarketingLeadAction();
        }
      } else {
        this.submitting = false;
        this.getMarketingLeadAction();
      }
    },

    // Helper methods
    success(message) {
      this.$swal({
        title: "Success!",
        text: message,
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    error(message) {
      this.$swal({
        title: 'Error!',
        text: message,
        icon: 'error',
        customClass: {
          confirmButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });
    },
  


    
    async onSubmit() {
      this.submitting = true;
      const isValid = await this.$refs.AddForm.validate();
      if (isValid) {
        try {
          const payload = {
            ...this.form,
          };
          await this.postMarketingLeadAction(payload);
          this.success('Marketing Lead added successfully!');
        } catch (error) {
          this.error(error.response.data.message);
        } finally {
          this.submitting = false;
          this.$bvModal.hide("add-lead-modal");
          this.resetForm();
          await this.getMarketingLeadAction()
        }
      } else {
        this.submitting = false;
      }
    }
  },

  async mounted() {


    await this.getMarketingLeadAction()
      .then((response) => {
      })
      .catch((response) => {
        console.log(response);
      });

    await this.getMarketingCampaignAction()
      .then((response) => {
        this.marketingcampaign.map((v, i) =>
          this.campaigns.push({
            value: v.id,
            text: `${v.name}`,
          })
        );
      })
      .catch((response) => {
        console.log(response);
      });
  },
  setup(props) {
    return {
      PermissionList,
      HasPermission
    }
  }
};
</script>